"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isVisible = function isVisible(element) {
  var _document, _window;
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!element) return false;
  var boundingClientRect = element.getBoundingClientRect();
  var viewHeight = Math.max((_document = document) === null || _document === void 0 || (_document = _document.documentElement) === null || _document === void 0 ? void 0 : _document.clientHeight, (_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight);
  var offScreenAboveView = boundingClientRect.bottom + padding < 0;
  var offScreenBelowView = boundingClientRect.top - viewHeight - padding >= 0;
  return !offScreenAboveView && !offScreenBelowView;
};
var _default = exports["default"] = isVisible;